import React from 'react';
import './MenuItem.css';



const MenuItem = ({ item }) => {

  return (
    <div className="menu-item">

      <div className='image'>
        <img src={item.image} alt={item.name} /> {/* Menu Item Image */}
      </div>

      <div className="content">

        <div className="intro">
          <h4>{item.name}</h4> {/* Item Name */}
          <span className="price">${item.price}</span> {/* Item Price */}
        </div>

        <p>{item.description}</p> {/* Item Description */}

      </div>

    </div>
  );
};

export default MenuItem;